/**
 * Gets the logged in user data from session storage
 */
export const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

/**
 * Check if user is authenticated
 */
export const isUserAuthenticated = () => {
  return getLoggedinUser() !== null;
};

